<!-- 选择外部联系人 -->
<template>
  <div class="select-external-user">
    <div class="select-external-user__content" @click="handleOpenSelectExternalUserDialog">
      <div v-if="value" class="select-external-user__content__avatar">
        <img src="../../imgs/default-avatar.png" alt=""/>
      </div>
      <div class="select-external-user__content__text" :style="{ color: value ? '#000' : '#999' }">{{ renderText }}</div>
      <div class="select-external-user__content__arrow">
        <img src="../../imgs/arrow-down.svg" style="transform: rotate(90deg);">
      </div>
    </div>
    <SelectExternalUserDialog
      ref="selectExternalUserDialog"
      :value="value"
      :list="externalUserList"
      @setOwner="handleSetOwner"
    />
  </div>
</template>

<script>
import SelectExternalUserDialog from './SelectExternalUserDialog.vue'
export default {
  name: 'SelectExternalUser',
  components: {
    SelectExternalUserDialog
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedExternalUser: null,
      externalUserList: [],
      chatId: '',
      loadingGetExternalUserList: false
    }
  },
  computed: {
    renderText() {
      return this.selectedExternalUser ? this.selectedExternalUser.name : '请选择车主'
    }
  },
  async mounted() {
    await this.getChatId()
    this.getExternalUserList()
  },
  methods: {
    getChatId() {
      return this.$wechat.promise.then(async wx => {
        // 获取应用入口环境
        const entranceEnv = await wx.getEntranceEnv()
        // 从群聊环境进入应用
        if (entranceEnv !== 'group_chat_tools') return
        this.chatId = await wx.getCurExternalChat()
      })
    },
    async getExternalUserList() {
      if (!this.chatId) return (this.externalUserList = [])
      try {
        this.loadingGetExternalUserList = true
        const res = await this.$rest.aftersales.getOwnerServiceGroupCustomerList(this.chatId)()
        if (res.code) {
          this.showToast(res.message)
          return (this.externalUserList = [])
        }
        const _noHasChat = []
        const _hasChat = []
        res.data.optional_customers.forEach(item => {
          if (item.has_chat) {
            _hasChat.push(item)
          } else {
            _noHasChat.push(item)
          }
        })
        this.externalUserList = [..._noHasChat, ..._hasChat]
        if (_noHasChat.length === 1) this.handleSetOwner(_noHasChat[0])
      } finally {
        this.loadingGetExternalUserList = false
      }
    },
    handleOpenSelectExternalUserDialog() {
      this.$refs.selectExternalUserDialog.open()
    },
    handleSetOwner(item) {
      this.selectedExternalUser = item
      this.$emit('input', item.external_userid)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../../stylesheets/base/fn.less';

.select-external-user {
  &__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20/@w2;
    height: 100/@w2;
    border: 1px solid #d9d9d9;
    border-radius: 6/@w2;
    .gap-x(20/@w2);

    &__avatar {
      width: 70/@w2;
      height: 70/@w2;
      border-radius: 50%;
      overflow: hidden;
    }

    &__text {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 30/@w2;
    }

    &__arrow {
      width: 30/@w2;
      height: 30/@w2;
    }
  }
}
</style>
